import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import { Cart } from '@features/cart/interfaces/cart.interface';
import { CartService } from '@features/cart/services/cart.service';
import { CheckoutService } from '@features/checkout/services/checkout.service';
import { faPercent, faStore, faTrash } from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css'],
})
export class CartComponent implements OnInit, OnDestroy {
  cart?: Cart;
  shopItems: any;
  storeIcon = faStore;
  promoIcon = faPercent;
  trashIcon = faTrash;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private router: Router,
    private layoutService: LayoutService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.layoutService.isMobile$.value) {
        this.layoutService.setFooterVisibility(false);
        this.layoutService.setMobileLayoutConfig({
          headerNav: {
            backButton: true,
            title: 'My Cart',
            searchButton: false,
            cartButton: false,
            notificationButton: false,
            userButton: true,
          },
          bottomNav: {
            visibillity: false,
          },
        });
      }
    }
  }

  ngOnInit(): void {
    this.cartService.cart$.subscribe((cart: Cart) => {
      this.cart = cart;
      this.shopItems = this.checkoutService.getCartProductShop(
        this.cart.cartItems
      );
    });
  }
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.layoutService.isMobile$.value) {
        this.layoutService.setFooterVisibility(true);
        this.layoutService.setDefaultMobileLayoutConfig();
      }
    }
  }
  onChangeQty(add: boolean = false, id: number, qty: number) {
    if (add) {
      this.cartService.updateCartItem(id, qty + 1).subscribe(() => {});
    } else {
      this.cartService.updateCartItem(id, qty - 1).subscribe(() => {});
    }
  }

  onChangeQtyByInput(id: number, qty: number) {
    this.cartService.updateCartItem(id, qty).subscribe(() => {});
  }

  deleteCart(id: number) {
    if (confirm('Apakah kamu yakin ingin menghapusnya ?')) {
      this.cartService.removeCartItem(id).subscribe(() => {
        alert('Berhasil Menghapus');
      });
    }
  }

  navigateToCheckout() {
    this.router.navigate(['/checkout']);
  }
}
